import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AdminGuardedRoute from '../guards/AdminGuardedRoute';
import Dashboard from '../../containers/Admin/Dashboard';
import NotFound from '../../containers/NotFound';
import Orders from '../../containers/Admin/Orders';
import OrderPage from '../../containers/Admin/OrderPage';
import Billing from '../../containers/Admin/Billing';
import Products from '../../containers/Admin/Products';
import { SideMenu } from '../../components/SideBarMenu/SideMenu';
import ProductDatabase from '../../containers/Admin/ProductDatabase';
import AddNewProduct from '../../containers/Admin/AddNewProduct';
import TransportationFormula from '../../containers/Admin/TransportationFormula';
import Contracts from '../../containers/Admin/Contracts';
import AddNewContract from '../../containers/Admin/AddNewContract';

const AdminRouter: React.FC = () => {
	const ADMIN_MENU = [
		{ logo: 'Shield Check', alt: 'Companies', url: '/companies' },
		{
			logo: 'Document Add',
			alt: 'Orders',
			url: '/orders',
			count: true,
		},
		{ logo: 'Money Bag', alt: 'Billing', url: '/billing' },
		{ logo: 'Bag', alt: 'Products', url: '/products' },
		{ logo: 'Bag 4', alt: 'Product database', url: '/product-database' },
		{
			logo: 'TF Truck',
			alt: 'Transportation formula',
			url: '/transportation-formula',
		},
		{
			logo: 'Admin Contracts',
			alt: 'Contracts',
			url: '/contracts',
		},
	];

	return (
		<Routes>
			<Route
				path="/companies"
				element={
					<AdminGuardedRoute>
						<SideMenu groups={ADMIN_MENU}>
							<Dashboard />
						</SideMenu>
					</AdminGuardedRoute>
				}
			/>
			<Route
				path="/orders"
				element={
					<AdminGuardedRoute>
						<SideMenu groups={ADMIN_MENU}>
							<Orders />
						</SideMenu>
					</AdminGuardedRoute>
				}
			/>
			<Route
				path="/orders/:orderId"
				element={
					<AdminGuardedRoute>
						<SideMenu groups={ADMIN_MENU}>
							<OrderPage />
						</SideMenu>
					</AdminGuardedRoute>
				}
			/>
			<Route
				path="/billing"
				element={
					<AdminGuardedRoute>
						<SideMenu groups={ADMIN_MENU}>
							<Billing />
						</SideMenu>
					</AdminGuardedRoute>
				}
			/>
			<Route
				path="/products"
				element={
					<AdminGuardedRoute>
						<SideMenu groups={ADMIN_MENU}>
							<Products />
						</SideMenu>
					</AdminGuardedRoute>
				}
			/>
			<Route
				path="/product-database"
				element={
					<AdminGuardedRoute>
						<SideMenu groups={ADMIN_MENU}>
							<ProductDatabase />
						</SideMenu>
					</AdminGuardedRoute>
				}
			/>
			<Route
				path="product-database/new"
				element={
					<AdminGuardedRoute>
						<SideMenu groups={ADMIN_MENU}>
							<AddNewProduct />
						</SideMenu>
					</AdminGuardedRoute>
				}
			/>
			<Route
				path="transportation-formula"
				element={
					<AdminGuardedRoute>
						<SideMenu groups={ADMIN_MENU}>
							<TransportationFormula />
						</SideMenu>
					</AdminGuardedRoute>
				}
			/>
			<Route
				path="contracts"
				element={
					<AdminGuardedRoute>
						<SideMenu groups={ADMIN_MENU}>
							<Contracts />
						</SideMenu>
					</AdminGuardedRoute>
				}
			/>
			<Route
				path="contracts/new"
				element={
					<AdminGuardedRoute>
						<SideMenu groups={ADMIN_MENU}>
							<AddNewContract />
						</SideMenu>
					</AdminGuardedRoute>
				}
			/>
			<Route
				path="/contracts/:contractId"
				element={
					<AdminGuardedRoute>
						<SideMenu groups={ADMIN_MENU}>
							<Contracts />
						</SideMenu>
					</AdminGuardedRoute>
				}
			/>
			<Route path="/*" element={<NotFound />} />
		</Routes>
	);
};

export default AdminRouter;
